export default __webpack_public_path__ + "static/media/041-Butter.415eb7ff.svg";